<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row justify-content-center">
      <div class="card-box col-12 col-md-8">
        <b-form-select v-model="selectedMeter" :options="meterList">
        </b-form-select>
      </div>

      <div class="card-box col-12 col-md-8">
        <apexchart
          ref="usagechart"
          type="bar"
          height="480"
          :options="chartOptions"
          :series="graphData"
        ></apexchart>
      </div>

      <div class="col-12 col-md-8">
        <div class="row" style="min-height: 360px; max-height: 745px; overflow-y: auto; overflow-x: hidden">
          <div class="col-12">
            <div class="table-responsive mb-0">
              <table class="table table-hover table-centered mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="text-center">Start Date</th>
                    <th class="text-center">End Date</th>
                    <th class="text-right">Days</th>
                    <th class="text-right">Period Usage</th>
                    <th class="text-right">Daily Average</th>
                    <th class="text-left">Unit</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="meter in selectedMetering"
                    :key="meter.invoice_metering_id"
                  >
                    <td class="text-center">{{ meter.invoice_start_date }}</td>
                    <td class="text-center">{{ meter.invoice_end_date }}</td>
                    <td class="text-right">{{ meter.period_days }}</td>
                    <td class="text-right">{{ meter.period_usage }}</td>
                    <td class="text-right">{{
                      Math.round((meter.period_usage * 1000) / meter.period_days) /
                        1000
                    }}</td>
                    <td class="text-left">{{ meter.uom_code }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { reqAccountMetering } from '@services'

export default {
  page: {
    title: 'Meter',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: 'Meter',
      items: [
        {
          text: 'Home',
          href: '/home',
        },
        {
          text: 'Meter',
          active: true,
        },
      ],

      accountID: null,
      accountMetering: [],

      selectedMeter: null,
      meterList: [],
      selectedMetering: [],
      graphData: [],
      chartOptions: {
        chart: {
          id: 'area-datetime',
          type: 'bar',
          height: 480,
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        markers: {
          size: 0,
          style: 'hollow',
        },
        xaxis: {
          type: 'datetime',
          tickAmount: 6,
        },
        yaxis: {
          decimalsInFloat: 0,
        },
        tooltip: {
          x: {
            format: 'MMM yyyy',
            // formatter: function (val) {
            //       return "Period End: " + val
            //     }
          },
        },
        fill: {
          colors: ['#0079FB'],
          type: 'gradient', // gradient
          gradient: {
            type: 'vertical', // The gradient in the horizontal direction
            gradientToColors: ['#00C3DF'], // The color at the end of the gradient
            opacityFrom: 1, // transparency
            opacityTo: 0.6,
            stops: [0, 80],
          },
        },
      },
    }
  },

  watch: {
    '$store.state.auth.account_id': function(val) {
      if (val) {
        this.getAccountMetering()
      }
    },
    
    selectedMeter: function(val) {
      this.getGraphData()
    },
  },

  mounted() {
    if (this.$store.state.auth.current_account_setup) {
      this.getAccountMetering()
    }
  },

  methods: {
    // Get Metering List
    async getAccountMetering() {
      const meteringResult = await reqAccountMetering({
        account: this.$store.state.auth.account_id,
      })

      if (meteringResult.status === 'Success') {
        this.accountMetering = meteringResult.data
        this.meterList = this.getDisctictMeterList()
        if (this.meterList.length > 0) {
          this.selectedMeter = this.meterList[0].value
          this.getGraphData()
        }
      }
    },

    getGraphData() {
      const usageList = []
      this.graphData = []

      this.selectedMetering = this.accountMetering.filter(
        (item) => item.meter_id === this.selectedMeter
      )

      this.selectedMetering.map((item) =>
        usageList.push([
          new Date(item.invoice_end_date).getTime(),
          item.period_usage,
        ])
      )

      //   console.log(new Date('2021-10-01').getTime() - new Date('2021-9-01').getTime())
      // if (usageList.length <= 6) {
      //   var minDate = usageList[0][0]
      //   for (var i = usageList.length; i < 6; i++) {
      //     usageList.push([minDate - ((24*24*60*100000) * i), null])
      //   }

      // } else {

      // }

      // usageList.forEach((item) => {
      //   console.log(new Date(item[0]))
      // })

      // console.log("usageList = ", usageList)

      this.graphData.push({
        name: 'Period Usage',
        data: usageList,
      })

      // console.log('getGraphData = ', this.graphData)
    },

    // Get a Distinct Meter List
    getDisctictMeterList() {
      let meterList = []
      let meterIDList = []
      this.accountMetering.forEach((item) => {
        if (meterIDList.indexOf(item.meter_id) === -1) {
          meterIDList.push(item.meter_id)
          meterList.push({
            value: item.meter_id,
            text: item.meter_num + ' - ' + item.utility_type_desc,
          })
        }
      })
      return meterList
    },
  },
}
</script>
